import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-itfacility-revoke-final-approver-grid',
  templateUrl: './itfacility-revoke-final-approver-grid.component.html',
  styleUrls: ['./itfacility-revoke-final-approver-grid.component.scss']
})
export class ITFacilityRevokeFinalApproverGridComponent implements OnInit {

  constructor(public appservice:AppService,public router:Router) { }
editEmployee(data){
  this.appservice.FinalRevokeEdit=data;
  //console.log("the edit id",this.appservice.hrclosureeditid);
  this.router.navigate(['/home/FinalRevokeReview'])
}
public RevokeGrid:any[]=[];
GetRevokedData(){
   this.RevokeGrid=[];
  this.appservice.getTable("api/Transaction/pr_Get_RevokeData_forFinal").subscribe((res:any)=>{
    this.RevokeGrid=JSON.parse(res);
    //console.log("the values",this.hrclosuredata);
      });
}
GetOnboardingGrid(){
  this.appservice.Hrcloser_type="Onboarding";
  this.appservice.gethrclosuredata();
}
GetOffboardingGrid(){
  this.appservice.Hrcloser_type="Offboarding";
  this.appservice.GetOffboardingDetails();
}
  ngOnInit(): void {
    this.GetRevokedData()
  }

}
